export default __webpack_public_path__ + "static/media/rl-4-rMIN.cd69b544.jpg";